<template src="./Header.html"></template>

<script>
import { Options, Vue } from 'vue-class-component'

// import '@/assets/lib/jquery/jquery-3.4.1.min.js';
// import jQuery from 'jquery'
// Vue.prototype.jQuery = jQuery
// window.jQuery = jQuery

// import 'jquery'
// import $ from 'jquery';
import jQuery from 'jquery';

    let $ = jQuery;
import '@/assets/styles/custom.css';
// import '@/assets/lib/slidebars/component-slidebars.min.css';
import slidebars from '@/assets/lib/slidebars/slidebars.min.js';
import axios from "axios";
// import '@/assets/lib/slidebars/component-slidebars.min.js';
export default class Header extends Vue{
  mounted() {
    let _Openmenu = false
    let _OpenSubmenu = false
    let MenuLang = {
      home: {
        en: "HOME",
        th: "หน้าแรก"
      },
      MGModelsDropdown: {
        en: "MG MODELS",
        th: "รุ่นรถ"
      },
      onlineBooking: {
        en: "ONLINE BOOKING",
        th: "จองออนไลน์"
      },
      promotion: {
        en: "PROMOTION",
        th: "โปรโมชัน"
      },
      service: {
        en: "SERVICES",
        th: "บริการหลังการขาย"
      },
      InnovationsDropdown: {
        en: "INNOVATIONS",
        th: "นวัตกรรม"
      },
      NewsActivitiesDropdown: {
        en: "NEWS & ACTIVITIES",
        th: "ข่าวสารและกิจกรรม"
      },
      AboutMGDropdown: {
        en: "ABOUT MG",
        th: "เกี่ยวกับเรา"
      },
      webTestDrive: {
        en: "TEST DRIVE",
        th: "ทดลองขับเอ็มจี"
      },
      webFindDealers: {
        en: "FIND A SHOWROOM",
        th: "ค้นหาผู้จำหน่ายเอ็มจี"
      },
      webFindCharger: {
        en: "FIND A CHARGING STATION",
        th: "ค้นหาสถานีชาร์จ"
      },
    }
    $('.en').hide()
    $('.th').show()
    $('#rightMenuBT').on('click', function(event) {
      _Openmenu = !_Openmenu
      if(_Openmenu){
        $("#page").addClass('openRmenu').removeClass('closeRmenu')
        // $('div.modal-backdrop').remove()
      }else{
        $("#page").addClass('closeRmenu').removeClass('openRmenu')
      }
    })
    $('li.dropdown > a').on('click', function(event) {
      $(`div.dropdown-menu`).removeClass('show')
      _OpenSubmenu = !_OpenSubmenu
      if(_OpenSubmenu){
        $(`#${event.target.id} + div.dropdown-menu`).addClass('show')
      }else{

      }
      // console.log(event)
      // console.log(event.target.id)
      // console.log($(this))
    });
    // if(!sessionStorage.LANG){
    //   sessionStorage.setItem('LANG','th')
    // }else{
    //   $('.lang.active').removeClass('active')
    //   $(`.lang[lang='${sessionStorage.LANG}']`).addClass('active')
    // }
    //
    // // $('.th,.en').hide()
    // console.log((sessionStorage.LANG))
    // // $(`.${sessionStorage.LANG}`).css({"display":"block !important"})
    // // $(`.${sessionStorage.LANG}`).show()
    // $('.lang').on('click',(evt)=>{
    //   sessionStorage.setItem('LANG',evt.currentTarget.innerHTML)
    //   location.reload()
    // })

//    (function($) {
//   var controller = new slidebars();
//   controller.init();
//   $('.navbar-toggle-offcanvas-left').on('click', function(event) {
//     event.stopPropagation();
//     event.preventDefault();
//     controller.toggle('offcanvas-left');
//   });
//   $('.navbar-toggle-offcanvas-right').on('click', function(event) {
//     event.stopPropagation();
//     event.preventDefault();
//     controller.toggle('offcanvas-right');
//   });
// })(jQuery);

    function ChengMenuLang() {
      for(let menuId in MenuLang) {
        $(`#${menuId}`).text(`${MenuLang[`${menuId}`][`${sessionStorage.LANG}`]}`);
      }
    }
    if(!sessionStorage.LANG){
      sessionStorage.setItem('LANG','th')
      sessionStorage.setItem('OLD_LANG','th')
    }else{
      // $('.lang.active').removeClass('active')
      // $(`.lang[lang='${sessionStorage.LANG}']`).addClass('active')
      ChengMenuLang()
    }

    // $('.th,.en').hide()
    console.log((sessionStorage.LANG))
    $('.lang').on('click',async (evt)=>{
      sessionStorage.setItem('LANG',evt.currentTarget.innerHTML)
      ChengMenuLang()
      // location.reload()
      let r = await axios.get(`https://onlinebookingapi.mgcars.com/v1/cartype/menu`, {headers: {
          "lang": sessionStorage.LANG
        }})
      let data = r.data;
      if (data.header.res_code == 200) {
        if (data.body.length) {
          $("#carModel").html('')
          let currentId = null;
          for (let i = 0; i < data.body.length; i++) {
            if (i % 5 == 0) {
              currentId = `carModel${i}`;
              $("#carModel").append(`<div class="row" id="${currentId}">`)
            }
            $(`#${currentId}`).append(`<div class="col-3 border-bottom border-right pt-4 position-relative">
                                        <a href="${data.body[i].link}"><img
                                                src="${data.body[i].image}"
                                                class="img-fluid1"
                                                alt="https://www.mgcars.com/${data.body[i].name}"><span>${data.body[i].name}</span></a>
                                    </div>`)
          }
        }
      }
    })
  }
  async created() {
    function getCarModels() {
      // token,pin
      return new Promise(async (resolve, reject) => {
        let r = await axios.get(`https://onlinebookingapi.mgcars.com/v1/cartype/menu`, {headers: {
            "lang": sessionStorage.LANG
          }})
        let data = r.data;
        if (data.header.res_code == 200) {
          if (data.body.error) resolve(data.body.error.message)
          if (data.body.length) {
            $("#carModel").html('')
            let currentId = null;
            for (let i = 0; i < data.body.length; i++) {
              if(i % 5 == 0) {
                currentId = `carModel${i}`;
                $("#carModel").append(`<div class="row" id="${currentId}">`)
              }
              $(`#${currentId}`).append(`<div class="col-3 border-bottom border-right pt-4 position-relative">
                                        <a href="${data.body[i].link}"><img
                                                src="${data.body[i].image}"
                                                class="img-fluid1"
                                                alt="https://www.mgcars.com/${data.body[i].name}"><span>${data.body[i].name}</span></a>
                                    </div>`)
            }
            return resolve(true)
          }
          return resolve(false)
        } else return resolve(data.header.res_desc)
      })
    }
    await getCarModels()
  }
}
</script>
<style src="./Header.scss" scoped lang="scss"></style>
